import React, { Component, Suspense } from "react";
import * as ReactDOM from "react-dom";
const folderName = window.sessionStorage.getItem("homeName");
const Home = React.lazy(() => import("../" + folderName + "/home"));
const Header = React.lazy(() => import("../" + folderName + "/header"));
const Footer = React.lazy(() => import("../" + folderName + "/footer"));
export default class Common extends Component {
  componentDidMount() {
    let name = ""//this.props.match.params.pageName;
    //alert(name);
    this.loadPage(name);
  }
  loadPage(name) {
    //const LazyPage = React.lazy(() => import("./" + folderName + "/home/" + name));
    const LazyPage = React.lazy(() => import("../" + folderName + "/themeContent"));
    ReactDOM.render(
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <section>
            <LazyPage />
          </section>
        </Suspense>
      </div>,
      document.getElementById("commonLoader")
    );
  }
  render() {
    return (
      // <div className="purpleWrap home bg-clr-wthHead">
      <div>
        <Suspense fallback={<div></div>}>
          <section>
            <Header />
          </section>
        </Suspense>
        <div id="commonLoader">211212</div>
        <Suspense fallback={<div></div>}>
          <section>
            <Footer />
          </section>
        </Suspense>
      </div>
    );
  }
}
